module.exports = __webpack_public_path__ + "img/logo2.c60f3caf.jpg";